import React from 'react';
import {
    DateRange,
    AccessTime,
    Person,
    Image as ImageIcon,
    WavingHand,
    QrCode,
    AutoAwesome,
    Share,
} from '@mui/icons-material';
import { WelcomeBoardLayout, WelcomeBoardWidgetType } from '../../../common/interfaces';
import { WidgetDefinition } from './types';

export const WIDGET_DEFINITIONS: WidgetDefinition[] = [
    {
        type: WelcomeBoardWidgetType.DateAndTime,
        name: 'Date & Time',
        icon: React.createElement(DateRange),
        description: 'Display current date and time',
        canHaveContent: false
    },
    {
        type: WelcomeBoardWidgetType.AppointmentInfo,
        name: 'Appointment Info',
        icon: React.createElement(AccessTime),
        description: 'Show appointment details',
        canHaveContent: false
    },
    {
        type: WelcomeBoardWidgetType.Image,
        name: 'Image',
        icon: React.createElement(ImageIcon),
        description: 'Display an image or logo',
        canHaveContent: true
    },
    {
        type: WelcomeBoardWidgetType.PatientGreeting,
        name: 'Patient Greeting',
        icon: React.createElement(WavingHand),
        description: 'Personalized patient welcome message',
        canHaveContent: false
    },
    {
        type: WelcomeBoardWidgetType.ProviderInfo,
        name: 'Provider Info',
        icon: React.createElement(Person),
        description: 'Display provider information',
        canHaveContent: false
    },
    {
        type: WelcomeBoardWidgetType.QrCode,
        name: 'QR Code',
        icon: React.createElement(QrCode),
        description: 'QR code for links or content',
        canHaveContent: true
    },
    {
        type: WelcomeBoardWidgetType.ServicesRotator,
        name: 'Services Rotator',
        icon: React.createElement(AutoAwesome),
        description: 'Rotating service information',
        canHaveContent: false
    },
    {
        type: WelcomeBoardWidgetType.SocialMedia,
        name: 'Social Media',
        icon: React.createElement(Share),
        description: 'Social media links and QR codes',
        canHaveContent: false
    }
];

export const ITEM_TYPE = 'WIDGET';
export const DRAWER_WIDTH = 280;
export const DROPDOWN_PADDING = 16;
export const DROPDOWN_MARGIN = 16;
export const DROPDOWN_HEIGHT = 50;

// Example layouts based on the constants from the .NET codebase
export const EXAMPLE_LAYOUTS: WelcomeBoardLayout[] = [
    {
        id: "123e4567-e89b-12d3-a456-426614174000",
        clientId: "",
        name: "Default Welcome Board Layout",
        gridColumnsTemplate: "repeat(3, 1fr)",
        gridRowsTemplate: "repeat(3, 1fr)",
        welcomeBoardItems: [
            {
                type: WelcomeBoardWidgetType.Image,
                gridColumn: "1",
                gridRow: "1",
                content: "demo-logo.png"
            },
            {
                type: WelcomeBoardWidgetType.DateAndTime,
                gridColumn: "2",
                gridRow: "1"
            },
            {
                type: WelcomeBoardWidgetType.AppointmentInfo,
                gridColumn: "1",
                gridRow: "2"
            },
            {
                type: WelcomeBoardWidgetType.PatientGreeting,
                gridColumn: "2",
                gridRow: "2"
            },
            {
                type: WelcomeBoardWidgetType.ServicesRotator,
                gridColumn: "3",
                gridRow: "1 / span 3"
            },
            {
                type: WelcomeBoardWidgetType.ProviderInfo,
                gridColumn: "1",
                gridRow: "3"
            },
            {
                type: WelcomeBoardWidgetType.SocialMedia,
                gridColumn: "2",
                gridRow: "3"
            }
        ]
    },
    {
        id: "145dcc20-5e21-478d-81e4-da044621cf04",
        clientId: "",
        name: "Default Empty Layout",
        gridColumnsTemplate: "repeat(3, 1fr)",
        gridRowsTemplate: "repeat(3, 1fr)",
        welcomeBoardItems: [
            {
                type: WelcomeBoardWidgetType.DateAndTime,
                gridColumn: "2",
                gridRow: "1"
            },
            {
                type: WelcomeBoardWidgetType.Image,
                gridColumn: "1 / span 3",
                gridRow: "2 / span 1",
                content: "demo-logo.png"
            }
        ]
    }
];